import React from "react";
import "./Club.css";
import img from "../../Assets/chest.png";
import img2 from "../../Assets/machine.png";
import img3 from "../../Assets/mansion.png";
import img4 from "../../Assets/wallet.png";
import img5 from "../../Assets/wyrming.png";
import mask from "../../Assets/metamask.png";
function Club() {
  return (
    <div className="club">
      <h1>Join The Club</h1>
      <p>When you buy a Mystical Pet, you’re not simply buying a JPEG or a provably-rare piece of art. You are gaining membership access to a club whose benefits and offerings will increase over time. A Mystical Pet evolves with time, can serve as your digital identity, and open digital doors for you. Invest in your future today.</p>
      <div className="club_img-div">
        <div className="image-box">
          <img src={img} alt="" />
          <p>Unique pets</p>
        </div>
        <div className="image-box">
          <img src={img3} alt="" />
          <p>An investment for your future </p>
        </div>
        <div className="image-box">
          <img src={img4} alt="" />
          <p>Community wallet gives you additional benefits</p>
        </div>
        <div className="image-box">
          <img src={img2} alt="" />
          <p>Lottery System gives your rewards monthly</p>
        </div>
        <div className="image-box">
          <img src={img5} alt="" />
          <p>Additional Benefits through roadmap activations</p>
        </div>
      </div>

      <div className="mask-div">
        <div className="left-mask">
          <h1>Owning a Mystical Pet is <br /> Extremely Easy</h1>
          <p>
            Get your MetaMask wallet set up which is needed <br /> for minting.<br /> All you
            need is 0.111 ETH+GAS, be connected to<br />the Mainnet and
            you're ready to go.
          </p>
        </div>
        <div className="right-mask">
          <img src={mask} alt="..." className="meta" />
          <button className="mask" onClick={(e) => {
              e.preventDefault();
              window.location.href='https://metamask.io/';
              }}>Get MetaMask</button>
        </div>
      </div>
    </div>
  );
}

export default Club;
